import axios from 'axios';

export const state = {
    allTypes: [],
    allGenders: [],
    allSports: [],
    allCountry: [],
    allSportsChild: [],
}

export const getters = {
    getAllTypes: (state) => state.allTypes,
    getAllGenders: (state) => state.allGenders,
    getAllSports: (state) => state.allSports,
    getAllCountry: (state) => state.allCountry,
    getAllSportsChild: (state) => state.allSportsChild
}

export const actions = {
    async fetchAllTypes({ commit }) {
        const response = await axios.get(`/parametersdp/all/type`);
        commit('SET_ALL_TYPES', response.data);
    },
    async fetchAllGenders({ commit }) {
        const response = await axios.get(`/parametersdp/all/gender`);
        commit('SET_ALL_GENDERS', response.data);
    },
    async fetchAllSports({ commit }) {
        const response = await axios.get(`/parametersdp/all/sport`);
        commit('SET_ALL_SPORTS', response.data);
    },
    async fetchAllCountry({ commit }) {
        const response = await axios.get(`/parametersdp/all/country`);
        commit('SET_ALL_COUNTRY', response.data);
    },
    async fetchAllSportsChild({ commit }) {
        const response = await axios.get(`/parametersdp/all/sportChild`);
        commit('SET_ALL_SPORTS_CHILD', response.data);
    },
}


export const mutations = {
    SET_ALL_TYPES: (state, result) => state.allTypes = result,
    SET_ALL_GENDERS: (state, result) => state.allGenders = result,
    SET_ALL_SPORTS: (state, result) => state.allSports = result,
    SET_ALL_COUNTRY: (state, result) => state.allCountry = result,
    SET_ALL_SPORTS_CHILD: (state, result) => state.allSportsChild = result,
}